import { render, staticRenderFns } from "./product.vue?vue&type=template&id=57690b22&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=57690b22&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57690b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\mam\\home\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57690b22')) {
      api.createRecord('57690b22', component.options)
    } else {
      api.reload('57690b22', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=57690b22&scoped=true", function () {
      api.rerender('57690b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/product.vue"
export default component.exports